import { render, staticRenderFns } from "./checkboxField.vue?vue&type=template&id=72fbe1fb&scoped=true&lang=pug&"
import script from "./checkboxField.vue?vue&type=script&setup=true&lang=js&"
export * from "./checkboxField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./checkboxField.vue?vue&type=style&index=0&id=72fbe1fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fbe1fb",
  null
  
)

export default component.exports